export const UPDATE_ROOM_ERROR_MESSAGE = "Error updating room";
export const UPDATE_ROOM_ERP_INTEGRATIONS_ERROR_MESSAGE =
  "The room was saved, but the update could not be synchronized with the external integrations. Please try again later.";
export const ROOM_NOT_FOUND_ERROR_MESSAGE = "Room not found";
export const GUESTY_LISTING_ALREADY_LINKED_ERROR_MESSAGE = "Guesty listing";
export const CREATE_ROOM_ERROR_MESSAGE = "Error creating room";
export const CREATE_ROOM_ERP_INTEGRATIONS_ERROR_MESSAGE =
  "The room was created, but the data could not be synchronized with the external integrations. Please try again later.";
export const AVANTIO_ACCOMMODATION_ALREADY_LINKED_ERROR_MESSAGE = "Avantio accommodation";
export const ICNEA_PROPERTY_ALREADY_LINKED_ERROR_MESSAGE = "Icnea property";
